import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiUserPlus, FiLogIn } from "react-icons/fi";

const Header = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation();
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);


    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    const studentToken = localStorage.getItem('student-token');
    const tutorToken = localStorage.getItem('tutor-token');


    const isNewStudentRoute = pathname.includes('/student/');
    const isNewTutorRoute = pathname.includes('/tutor/');

    const handleLoginClick = () => {
        if (studentToken) {
            navigate('/student/dashboard');
        }
        else if (tutorToken) {
            navigate('/tutor/dashboard');
        }
        else {

            if (isNewStudentRoute) {
                navigate('/student/login');
            } else if (isNewTutorRoute) {
                navigate('/tutor/login');
            } else {
                navigate('/login');
            }
        }
    };


    const getRegisterLink = () => {
        if (isNewStudentRoute) {
            return '/student/register';
        } else if (isNewTutorRoute) {
            return '/tutor/register';
        } else {
            return '/register';
        }
    };


    const getLoginLink = () => {
        if (isNewStudentRoute) {
            return '/student/login';
        } else if (isNewTutorRoute) {
            return '/tutor/login';
        } else {
            return '/login';
        }
    };

    return (
        <header>
            <div id="home">
                <header className="header-wrap style1">
                    <div className="container">
                        <div className="header-bottom">
                            <div className="row align-items-baseline ">
                                <div className="col-xl-2 col-lg-2 col-md-3 col-sm-3 d-flex justify-content-center">
                                    <Link to="/" className="logo">
                                        <img
                                            src="/website/assets/img/logo.png"
                                            alt="Image"
                                            className="img-fluid"
                                        />
                                    </Link>
                                </div>
                                <div className="col-xl-6 col-lg-7 col-md-2 col-sm-2">
                                    <div className={`main-menu-wrap ${isMobileMenuOpen ? 'open' : ''}`}>
                                        <div className="menu-close d-lg-none" onClick={toggleMobileMenu}>
                                            <Link to="javascript:void(0)">
                                                <i className="las la-times" />
                                            </Link>
                                        </div>
                                        <nav id="menu">
                                            <ul className="main-menu  d-flex justify-content-center  " >
                                                <li className="has-children mx-2">
                                                    <Link className={`${pathname === '/' ? 'active' : ''}`} to="/">
                                                        Home
                                                    </Link>
                                                </li>
                                                <li className="has-children mx-2">
                                                    <Link className={`${pathname === '/find-tutor' ? 'active' : ''}`} to="/find-tutor">Find a Tutor</Link>
                                                </li>
                                                <li className="has-children mx-2">
                                                    <Link className={`${pathname === '/become-tutor' ? 'active' : ''}`} to="/become-tutor">Become a Tutor</Link>
                                                </li>
                                                <li className="has-children mx-2">
                                                    <Link className={`${pathname === '/about-us' ? 'active' : ''}`} to="/about-us">About Us</Link>
                                                </li>
                                                <li className="has-children mx-2">
                                                    <Link className={`${pathname === '/blog' ? 'active' : ''}`} to="/blog">Blog</Link>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                                {/* <div className="col-xl-4 col-lg-3 col-md-6 col-sm-6 d-flex end-section pt-3">
                                    <ul
                                        className="nav header-navbar-rht d-flex justify-content-end "
                                        style={{ gap: 7 }}
                                    >
                                        <li className="nav-item">

                                            <Link
                                                className={`nav-link ${pathname === getRegisterLink() ? 'header-login' : ''}`}
                                                to={getRegisterLink()}
                                            >

                                                Register
                                            </Link>
                                        </li>
                                        <li className="nav-item">

                                            <a
                                                className={`nav-link ${pathname === getLoginLink() ? 'header-login' : ''}`}
                                                onClick={handleLoginClick}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                {studentToken || tutorToken ? 'Go to dashboard' : 'Log In'}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    className="col-xl-3 col-lg-3 col-md-3 col-sm-3"
                                   
                                >
                                    <div className="mobile-bar-wrap d-lg-none">
                                        <div className="mobile-top-bar" onClick={toggleMobileMenu}>
                                            <span />
                                            <span />
                                            <span />
                                        </div>
                                        <div className="mobile-menu">
                                            <Link to="javascript:void(0)" onClick={toggleMobileMenu}>
                                                <i className="las la-bars" />
                                            </Link>
                                        </div>
                                    </div>
                                </div> */}

                                <div className="col-xl-4 col-lg-3 col-md-6 col-sm-6 header-actions">

                                    {/* Buttons */}
                                    <ul className="nav header-navbar-rht gap-2">
                                        <li className="nav-item">
                                            <Link className="nav-link" to={getRegisterLink()}>
                                                Register
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" onClick={handleLoginClick}>
                                                {studentToken || tutorToken ? 'Dashboard' : 'Log In'}
                                            </a>
                                        </li>
                                    </ul>

                                    {/* Hamburger */}
                                    <div className="mobile-bar-wrap" onClick={toggleMobileMenu}>
                                        <div className="mobile-top-bar">
                                            <span />
                                            <span />
                                            <span />
                                        </div>
                                        <div className="mobile-menu">
                                            <Link to="javascript:void(0)" onClick={toggleMobileMenu}>
                                                <i className="las la-bars" />
                                            </Link>
                                        </div>
                                    </div>

                                </div>
                            </div>



                        </div>
                    </div>
                </header>
            </div>
        </header>
    );
};

export default Header;